import * as BABYLON from 'babylonjs';
import { Prefab } from '@/store/flux360/PrefabDataTypes';

import { Audio, BasicComponent, Text, Transition, URLButton, Viewer3D, User, Image, Video, VideoList, ImageSphere, VideoSphere } from '@/components/flux360/components';
import { NotifyPosition } from './components';

class Constructor {
    getType() { return "Prefab"; }

    construct( context, prefab ) {
        return new BasicComponent( 
            { 
                id: prefab.getSituationID ? prefab.getSituationID() : undefined,
                rootNode: new BABYLON.TransformNode(prefab.getType() + "_" + prefab.getID(), window.scene)
            });
    }
}

class TextConstructor extends Constructor {
    getType() { return Prefab.PrefabType.TextContent; }

        construct( context, prefab ) {
            let t = new Text();
            t.construct( context, prefab );
            return t;
        }
       
}

class VideoConstructor extends Constructor {
    getType() { return Prefab.PrefabType.VideoContent; }

    construct( context, prefab ) {
        console.log("VideoConstructor - starting to construct...");
        let v = new Video();
        v.construct( context, prefab );
        return v;
    }
  
}

class VideoListConstructor extends Constructor {
    getType() { return Prefab.PrefabType.VideoListContent; }

    construct( context, prefab ) {
        console.log("VideoListConstructor - starting to construct...");
        let v = new VideoList();
        v.construct( context, prefab );
        return v;
    }
  
}

class ImageConstructor extends Constructor {
    getType() { return Prefab.PrefabType.ImageContent; }

    construct( context, prefab ) {
        console.log("ImageConstructor - starting to construct...");
        let i = new Image();
        i.construct( context, prefab );
        return i;
    }
  
}

class NotifyPositionConstructor extends Constructor {
    getType() { return "NotifyPositionEvent"; }

    construct( context, event ) {
        let i = new NotifyPosition();
        i.construct( context, event );
        return i;
    }
  
}


class TransitionConstructor extends Constructor {
    getType() { return Prefab.PrefabType.Transition; }

    construct( context, prefab ) {
        let t = new Transition();
        t.construct( context, prefab );
        return t;
    }
}


class URLButtonConstructor extends Constructor {
    getType() { return Prefab.PrefabType.URLButton }

    construct( context, prefab ) {
        let urlB = new URLButton();
        urlB.construct( context, prefab );
        return urlB;
    }
}

class Viewer3DConstructor extends Constructor {
    getType() { return Prefab.PrefabType.Viewer3D }

    construct( context, prefab ) {
        let viewer = new Viewer3D();
        viewer.construct( context, prefab );
        return viewer;
    }
}

class SituationVideoConstructor extends Constructor {
    getType() { return Prefab.PrefabType.SituationVideo; }

    construct( context, prefab ) {
        let vSph = new VideoSphere();
        vSph.construct( context, prefab );
        return vSph;
    }

}

class AudioConstructor extends Constructor {
    getType() { return Prefab.PrefabType.AudioContent; }

    construct( context, prefab ) {
        let audio = new Audio();
        audio.construct( context, prefab );
        return audio;
    }
   
}

class SituationImageConstructor extends Constructor {
    getType() { return Prefab.PrefabType.SituationImage; }

    construct( context, prefab ) {
        let iSph = new ImageSphere();
        iSph.construct( context, prefab );
        return iSph;
    }
   
}

class UserCursorConstructor extends Constructor {
    getType() { return "User"; }

    construct( context, user ) {
        let t = new User();
        t.construct( context, user );
        return t;
    }
}

class ConstructorManager
{
    constructor() {
        this.constructors = new Map();
    }

    registerConstructor( c ) {
        if( c.getType ) {
            this.constructors.set( c.getType(), c );
        }
    }

    constructPrefabSubgraph( context, prefab ) {
        if( this.constructors.has( prefab.getType() )){
            return this.constructors.get(prefab.getType()).construct( context, prefab );
        }
        return this.constructors.get("Prefab").construct( context, prefab );
    }
}

const instance = new ConstructorManager();

instance.registerConstructor( new TextConstructor() );
instance.registerConstructor( new ImageConstructor() );
instance.registerConstructor( new VideoConstructor() );
instance.registerConstructor( new VideoListConstructor() );
instance.registerConstructor( new TransitionConstructor() );
instance.registerConstructor( new SituationImageConstructor() );
instance.registerConstructor( new SituationVideoConstructor() );
instance.registerConstructor( new UserCursorConstructor() );
instance.registerConstructor( new AudioConstructor() );
instance.registerConstructor( new URLButtonConstructor() );
instance.registerConstructor( new Viewer3DConstructor() );
instance.registerConstructor( new NotifyPositionConstructor() );
instance.registerConstructor( new Constructor() );

Object.freeze(instance);

export default instance;